<div class="unsupported-browsers-container">
  <link rel="stylesheet" href="https://kit-pro.fontawesome.com/releases/latest/css/pro.min.css" />
  <div class="modal fade cc-popup-modal cc-popup-modal-two" id="ccPopupModalTwo" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" onclick="$('.cdk-overlay-container').hide()" mat-button mat-dialog-close>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!--<span class="circle"><i class="fa fa-exclamation"></i></span>-->
          <img [src]="supportBrowsersResp.ExclamationImage" alt="" />
          <h4>Please upgrade your browser</h4>
          <div class="mb-0">We built Rate Tables using the latest techniques and technologies.<br>This makes Rate Tables faster and easier to use.</div>
          <div><div class="bolder">Unfortunately, your browser doesn't support those technologies.</div></div>
          <div class="logo-box">
            <p class="box-text">Download one of these great browsers and you'll be on your way:</p>
            <ul class="browsers-list">
              <li class="list-item" *ngFor="let browser of supportBrowsersResp.SupportedBrowsers">
                <a target="_blank" [href]="browser.DownloadUrl">
                  <img [src]="browser.Logo" alt="" />
                  <span class="title">{{ browser.BrowserName }}</span>
                  <span class="version">Version {{ browser.FriendlyVersion }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <br/>
          <div class="footer-title">FOR TECHNICAL SUPPORT</div>
          <ul class="modal-footer-links">
            <li><i class="far fa-phone-alt mr-2"></i>877.440.9469</li>
            <li class="m-0"><a href="mailto:helpdesk@wordandbrown.com"><i class="far fa-envelope mr-2"></i>helpdesk@wordandbrown.com</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
